const Navbar = () => {
	return (
		<nav className="py-3 px-12 h-16 font-semibold flex items-center bg-surface/90 backdrop-blur-md shadow-sm border-b border-white/20 sticky top-0 z-50 transition-all duration-300">
			<img
				src={process.env.PUBLIC_URL + "/assets/icons/favicon.ico"}
				className="h-8 mr-4 drop-shadow-sm"
				alt="logo"
			/>
			<h1 className="lg:mb-0 font-bold text-center text-text-heading text-xl tracking-tight">
				MOTION ADMIN
			</h1>
		</nav>
	);
};

export default Navbar;
